import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

const fetcher = (url) => api.get(url).then((r) => r.data);

export const useServices = () => useQuery({ queryKey: ["services"], queryFn: () => fetcher("/services") });
export const useVehicles = () => useQuery({ queryKey: ["vehicles"], queryFn: () => fetcher("/vehicles") });
export const usePackages = () => useQuery({ queryKey: ["packages"], queryFn: () => fetcher("/packages") });
export const useCities = () => useQuery({ queryKey: ["cities"], queryFn: () => fetcher("/cities") });
export const useReviews = () => useQuery({ queryKey: ["reviews"], queryFn: () => fetcher("/reviews") });
export const useBlogs = () => useQuery({ queryKey: ["blogs"], queryFn: () => fetcher("/blogs") });
export const useCity = (slug) => useQuery({ queryKey: ["city", slug], queryFn: () => fetcher(`/cities/${slug}`) });
export const useBlog = (slug) => useQuery({ queryKey: ["blog", slug], queryFn: () => fetcher(`/blogs/${slug}`) });
export const usePackage = (slug) => useQuery({ queryKey: ["package", slug], queryFn: () => fetcher(`/packages/${slug}`) });
export const useService = (slug) => useQuery({ queryKey: ["service", slug], queryFn: () => fetcher(`/services/${slug}`) });
